/**
 * @fileoverview Constantes generales del proyecto Zona Segura.
 * Centraliza constantes para evitar magic strings y facilitar mantenimiento.
 * @module constants
 */

/**
 * Tipos de acciones para reCAPTCHA v3.
 * LOGIN, SIGNUP, RECOVERY y OTP_RESEND son las acciones que valida CR Auth.
 */
export const RECAPTCHA_ACTIONS = {
  LOGIN: 'login',
  SIGNUP: 'signup',
  RECOVERY: 'password_recovery',
  OTP_RESEND: 'otp_resend',
  UPDATE_PASSWORD: 'update_password',
  CHANGE_PASSWORD: 'change_password',
  AUTO_LOGIN: 'auto_login'
}

export const PRODUCT_NAMES = {
  SOAT: 'SOAT'
}

/**
 * Motivos de anulación de póliza SOAT
 */
export const SOAT_CANCELLATION_REASONS = [
  'Problemas económicos',
  'Migración a la competencia',
  'Falta de veracidad en la información',
  'Cobros indebidos',
  'Insatisfacción con la atención',
  'Mala atención durante el siniestro',
  'Problemas con la gestión de solicitudes',
  'Problemas con endoso',
  'Problemas con el crédito mancomunado o préstamo',
  'Cambio en las necesidades del cliente',
  'No reconoce el seguro',
  'No brinda detalles / No contesta',
  'Adquirí otro producto',
  'No deseo la póliza',
  'Otros'
]

/**
 * Estados de trámites
 */
export const FORMALITY_STATES = {
  PENDING: 'PENDIENTE',
  APPROVED: 'APROBADO',
  REJECTED: 'RECHAZADO'
}

/**
 * Tipos de trámites
 */
export const FORMALITY_TYPES = {
  CANCELLATION: 'Anulación de póliza',
  DATA_UPDATE: 'ACTUALIZACION_DATOS',
  POLICY_CANCELLATION: 'ANULACION_POLIZA'
}

/**
 * Medios de respuesta
 */
export const RESPONSE_MEDIUMS = {
  ELECTRONIC: 'Electrónico',
  PHYSICAL: 'Físico'
}

/**
 * Códigos de respuesta de la API
 */
export const API_RESPONSE_CODES = {
  SUCCESS: '01',
  DUPLICATE_REQUEST: '98',
  ERROR: '00'
}

/**
 * Códigos de estado HTTP
 */
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  INTERNAL_ERROR: 500
}


// WEBPACK FOOTER //
// ./src/constants/index.js